import { CheckCircle2, TriangleAlert, X } from "lucide-react";

export interface ToastData {
  id: number;
  message: string;
  tone?: "success" | "error";
}

export default function Toast({
  toast,
  onClose,
}: {
  toast: ToastData | null;
  onClose: () => void;
}) {
  if (!toast) return null;
  return (
    <div className={`toast ${toast.tone === "error" ? "toast-error" : ""}`} role="status">
      {toast.tone === "error" ? <TriangleAlert size={20} /> : <CheckCircle2 size={20} />}
      <span>{toast.message}</span>
      <button onClick={onClose} aria-label="Fechar aviso">
        <X size={16} />
      </button>
    </div>
  );
}
